module.exports = __webpack_public_path__ + "img/morntoproimg.5c246ce4.png";